import { FC } from "react";
import * as React from "react";
import { Overlay, SideModal, SideModalContent } from "~/common/layout/Modals";
import Head from "~/common/layout/Head";
import Button from "~/common/elements/mobile/Button";
import { buttonSize, buttonStyle } from "~/common/elements/mobile/consts";

type Props = {
  headTitle: string;
  itemName: string;
  isLoading: boolean;
  error?: string;
  onClose: () => void;
  onDelete: () => void;
};

export const DeleteConfirmOverlay: FC<Props> = ({ headTitle, itemName, isLoading, error, onClose, onDelete }) => {
  return (
    <Overlay onClick={onClose} isLoading={isLoading}>
      <SideModal>
        <Head headTitle={headTitle} />
        <SideModalContent>
          <div className="confirmation__send">
            <h3 className="confirmation__send__heading">{`Are you sure you want to delete "${itemName}"?`}</h3>
            <div className="confirmation__send__buttons">
              <Button title="Yes" buttonStyle={`${buttonStyle.PRIM} ${buttonStyle.WHITE}`} buttonSize={buttonSize.LG} onClick={onDelete} />
              <Button title="No" buttonStyle={`${buttonStyle.PRIM} ${buttonStyle.WHITE}`} buttonSize={buttonSize.LG} onClick={onClose} />
            </div>
          </div>
          {error && <div className="form__note form__note--err">{error}</div>}
        </SideModalContent>
      </SideModal>
    </Overlay>
  );
};